import React, { Component } from 'react';
import { Link } from "react-router-dom";

import Header from './Header';
import Footer from './Footer';

import binder25 from '../img/binder-25.png';
import binder35 from '../img/binder-35.png';
import binder50 from '../img/binder-50.png';
import binder70 from '../img/binder-70.png';

class Home extends Component {
  state = {
    localStorageEnabled: null,
    binderSize: null,
    binderColor: '#e63749',
    lang: 'en',
    translations: {
    }
  }

  componentDidMount() {
    const location = window.location.pathname;
    if(location === "/en/") {
      this.setState({
        lang: 'en',
        translations: {
          title: 'Choose size of your Newbinder',
          stickerSize: 'Sticker size',
          binderColor: 'Choose binder colour',
          chooseSize: 'Choose size',
          createProject: 'Create projects',
        }
      });
    } else if (location === "/de/") {
      this.setState({
        lang: 'de',
        translations: {
          title: 'Wählen Sie die Größe Ihres Newbinders aus',
          stickerSize: 'Größe des Aufklebers',
          binderColor: 'Wählen Sie die Farbe des Ordners aus',
          chooseSize: 'Wählen Sie die Größe aus',
          createProject: 'Projekt erstellen',
        }
      });
    } else {
      this.setState({
        lang: 'pl',
        translations: {
          title: 'Wybierz rozmiar swojego Newbindera',
          stickerSize: 'Rozmiar naklejki',
          binderColor: 'Wybierz kolor',
          chooseSize: 'Wybierz rozmiar',
          createProject: 'Stwórz projekty',
        }
      });
    }

    function storageAvailable(type) {
      try {
          var storage = window[type],
              x = '__storage_test__';
          storage.setItem(x, x);
          storage.removeItem(x);
          return true;
      }
      catch(e) {
          return false;
      }
    }
    if (storageAvailable('localStorage')) {
      this.setState({
        localStorageEnabled: true,
      });
    }
    else {
      this.setState({
        localStorageEnabled: false,
      });
    }
  }

  handleSelect = ({target: {value, name}}) => this.setState({ [name]: value })

  render() {
    return (
      <div className="App">
        <Header/>
        {this.state.localStorageEnabled ?
          <div>
            <div className="container container__home container__homeMain">
              <p className="p--title text--center wg--300 color--black">
                {this.state.translations.title}
              </p>
              <div className="column__container">
                <div className="binder--selector col-25">
                  <img className="w--100" src={binder25} alt="NEWBINDER-25"/>
                  <div className="selector">
                    <div className="d--flexStart mb--10">
                      <div className={this.state.binderSize === "binder25" ? "picker picker--selected" : "picker"}>
                        <input type="radio" name="binderSize" value="binder25" onChange={this.handleSelect}/>
                      </div>
                      <p className="p--title color--black ml--20 wg--800">25</p>
                    </div>
                    <p className="p--md color--gray">{this.state.translations.stickerSize}:</p>
                    <p className="p--md">2cm x 16cm</p>
                  </div>
                </div>
                <div className="binder--selector col-25">
                  <img className="w--100" src={binder35} alt="NEWBINDER-35"/>
                  <div className="selector">
                    <div className="d--flexStart mb--10">
                      <div className={this.state.binderSize === "binder35" ? "picker picker--selected" : "picker"}>
                        <input type="radio" name="binderSize" value="binder35" onChange={this.handleSelect}/>
                      </div>
                      <p className="p--title color--black ml--20 wg--800">35</p>
                    </div>
                    <p className="p--md color--gray">{this.state.translations.stickerSize}:</p>
                    <p className="p--md">2,5cm x 16cm</p>
                  </div>
                </div>
                <div className="binder--selector col-25">
                  <img className="w--100" src={binder50} alt="NEWBINDER-50"/>
                  <div className="selector">
                    <div className="d--flexStart mb--10">
                      <div className={this.state.binderSize === "binder50" ? "picker picker--selected" : "picker"}>
                        <input type="radio" name="binderSize" value="binder50" onChange={this.handleSelect}/>
                      </div>
                      <p className="p--title color--black ml--20 wg--800">50</p>
                    </div>
                    <p className="p--md color--gray">{this.state.translations.stickerSize}:</p>
                    <p className="p--md">3cm x 16cm</p>
                  </div>
                </div>
                <div className="binder--selector col-25">
                  <img className="w--100" src={binder70} alt="NEWBINDER-70"/>
                  <div className="selector">
                    <div className="d--flexStart mb--10">
                      <div className={this.state.binderSize === "binder70" ? "picker picker--selected" : "picker"}>
                        <input type="radio" name="binderSize" value="binder70" onChange={this.handleSelect}/>
                      </div>
                      <p className="p--title color--black ml--20 wg--800">70</p>
                    </div>
                    <p className="p--md color--gray">{this.state.translations.stickerSize}:</p>
                    <p className="p--md">4cm x 16cm</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="container container__home container__color">
              <div className="d--flexBetween screenWrap">
                <p className="p--title-second wg--300">{this.state.translations.binderColor}:</p>
                <div className="d--flex color--selector">
                  <div className={this.state.binderColor === "#eaeaea" ? "colorPicker colorPicker--white colorPicker--selected" : "colorPicker"} style={{backgroundColor: "#eaeaea" }}>
                    <input type="radio" name="binderColor" value="#eaeaea" onChange={this.handleSelect}/>
                  </div>
                  <div className={this.state.binderColor === "#afafaf" ? "colorPicker colorPicker--selected" : "colorPicker"} style={{backgroundColor: "#afafaf" }}>
                    <input type="radio" name="binderColor" value="#afafaf" onChange={this.handleSelect}/>
                  </div>
                  <div className={this.state.binderColor === "#7c7c7c" ? "colorPicker colorPicker--selected" : "colorPicker"} style={{backgroundColor: "#7c7c7c" }}>
                    <input type="radio" name="binderColor" value="#7c7c7c" onChange={this.handleSelect}/>
                  </div>
                  <div className={this.state.binderColor === "#222222" ? "colorPicker colorPicker--selected" : "colorPicker"} style={{backgroundColor: "#222222" }}>
                    <input type="radio" name="binderColor" value="#222222" onChange={this.handleSelect}/>
                  </div>
                  <div className={this.state.binderColor === "#f4f0e1" ? "colorPicker colorPicker--white colorPicker--selected" : "colorPicker"} style={{backgroundColor: "#f4f0e1" }}>
                    <input type="radio" name="binderColor" value="#f4f0e1" onChange={this.handleSelect}/>
                  </div>
                  <div className={this.state.binderColor === "#ffda34" ? "colorPicker colorPicker--white colorPicker--selected" : "colorPicker"} style={{backgroundColor: "#ffda34" }}>
                    <input type="radio" name="binderColor" value="#ffda34" onChange={this.handleSelect}/>
                  </div>
                  <div className={this.state.binderColor === "#9ee6d9" ? "colorPicker colorPicker--selected" : "colorPicker"} style={{backgroundColor: "#9ee6d9" }}>
                    <input type="radio" name="binderColor" value="#9ee6d9" onChange={this.handleSelect}/>
                  </div>
                  <div className={this.state.binderColor === "#678ca3" ? "colorPicker colorPicker--selected" : "colorPicker"} style={{backgroundColor: "#678ca3" }}>
                    <input type="radio" name="binderColor" value="#678ca3" onChange={this.handleSelect}/>
                  </div>
                  <div className={this.state.binderColor === "#57746f" ? "colorPicker colorPicker--selected" : "colorPicker"} style={{backgroundColor: "#57746f" }}>
                    <input type="radio" name="binderColor" value="#57746f" onChange={this.handleSelect}/>
                  </div>
                  <div className={this.state.binderColor === "#e63749" ? "colorPicker colorPicker--selected" : "colorPicker"} style={{backgroundColor: "#e63749" }}>
                    <input type="radio" name="binderColor" value="#e63749" onChange={this.handleSelect}/>
                  </div>
                </div>
                <div className="d--flex">
                  <Link
                    className={this.state.binderSize? "btn--primary": "btn--primary btn--disabled"}
                    to={{
                      pathname: '/configurator',
                      state: {
                        binderSize: this.state.binderSize,
                        binderColor: this.state.binderColor
                      }
                    }}
                    >
                    {!this.state.binderSize? this.state.translations.chooseSize: this.state.translations.createProject}
                  </Link>
                </div>
              </div>
            </div>
          </div>
          :
          <div className="container container__home container__homeMain">
            <div className="container__info">
              <p className="p--xl color--blackSecond">Warning! Access to cookies is needed for the application to work!</p>
              <p className="color--grayFourth">Enable <span> cookies </span> in your browser settings, then restart the application. Cookies are used to save your changes made to the application.</p>
            </div>
          </div>
        }
        <Footer/>
      </div>
    )
  }
}

export default Home;
